$(document).ready(function(){
  // $('body').on('click','.custom-mobile-link', function(e){
  //   if ($(window).width() > 797) {
  //     $(this).closest('label').click();  
  //   } else {
  //     e.preventDefault();
  //     $(this).next(".close-dropdown").trigger("click");
  //   }
  // });

  // $('.thumbnail-add-to-cart__caption .product-thumbnail').matchHeight();
  
  if ( $('.custom-landing-page-image-grid-section .wulf-overlap-title').length ) {
    $('.custom-landing-page-image-grid-section .wulf-overlap-title').matchHeight();
  }

  var featuredReviewsSlider = $('#featuredReviewsWrapper');

  $(featuredReviewsSlider).flickity({
    lazyLoad: 2,
    freeScroll: true,
    imagesLoaded: true,
    draggable: true,
    autoPlay: true,
    cellAlign: 'center',
    wrapAround: true,
    pageDots: true,
    contain: true,
    prevNextButtons: true,
    initialIndex: 0,
    on: {
      ready: function ready() {
        // Reset layout to avoid collapsing issues
        setTimeout(function () {
          $(featuredCollectionSlider).flickity('resize');
        }, 500);
      }
    }
  });

  if ( $('#customFieldChefs').length ) {
    const chefReviews =  $('#customFieldChefs')

    chefReviews.flickity({
      wrapAround: true,
      imagesLoaded: false,
      initialIndex: 1,
      autoPlay: true,
      pauseAutoPlayOnHover: true,
      pageDots: false,
      on: {
        ready: function ready() {
          // Reset layout to avoid collapsing issues
          setTimeout(function () {
            chefReviews.flickity('resize');
            chefReviews.fadeIn().css('opacity','1');
          }, 600);
        }
      }
    });

    $('#chefTestimonialPrev').on('click',function() {
      chefReviews.flickity('previous');
    });

    $('#chefTestimonialNext').on('click',function() {
      chefReviews.flickity('next');
    });

    $('#chefTestimonialPlayPause').on('click', function() {
      const data = chefReviews.data('flickity');

      if (! data || ! data.player || ! data.player.state) {
        return;
      }

      if (data.player.state === 'playing') {
        chefReviews.flickity('stopPlayer');
        $('#chefTestimonialPlayPause')
          .attr('aria-label', 'play slider')
          .children('svg:first-child').fadeOut()
          .siblings('svg:last-child').fadeIn();
      } else {
        chefReviews.flickity('playPlayer');
        $('#chefTestimonialPlayPause')
          .attr('aria-label', 'pause slider')
          .children('svg:last-child').fadeOut()
          .siblings('svg:first-child').fadeIn();
      }
    });
  }

  if ( $('#articleImageGallery').length ) {
    $('#articleImageGallery').flickity({
      wrapAround: true,
      imagesLoaded: true,
      on: {
        ready: function ready() {
          // Reset layout to avoid collapsing issues
          setTimeout(function () {
            $(articleImageGallery).flickity('resize');
            $(articleImageGallery).fadeIn().css('opacity','1');
          }, 500);
        }
      }
    });
  }



  $("#articlesWrapperx .featured-article")
    .sort(sort_li) // sort elements
    .appendTo('#articlesWrapper'); // append again to the list

  $("#articlesWrapper")
    .css('opacity',1);
  
  // sort function callback
  function sort_li(a, b){
    // console.log(($(b).data('updated')) < ($(a).data('updated')) ? -1 : 1);
      return ($(b).data('updated')) < ($(a).data('updated')) ? -1 : 1;    
  }

  atcFormIsInView();

  var $cartAccordionHeading = $('#cartShippingMotivator .faq-accordion > dt > button');

  // console.log($cartAccordionHeading);
  $('#cartShippingMotivator .faq-accordion > dd').attr('aria-hidden', true);
  $cartAccordionHeading.attr('aria-expanded', false);
  $cartAccordionHeading.on('click activate', function () {
    // console.log('accordion click cart');
    var faqTitle = $(this);
    var faqIcons = $(this).find('.icon');
    var state = $(this).attr('aria-expanded') === 'false' ? true : false;
    $(this).attr('aria-expanded', state);
    $(this).parent().next().slideToggle(function () {
      if (faqIcons.hasClass('icon--active')) {
        faqIcons.toggleClass('icon--active');
      }
    });
    $(this).parent().next().attr('aria-hidden', !state);
    if ( $('#panel-articles').length ) {
      var minTitleHeight = 0;
      var minImageHeight = 0;
      $('#panel-articles .image-element__wrap').each(function(){
        // console.log($(this).height());
        if ( $(this).height() > minImageHeight ) {
          minImageHeight = $(this).height();
        }
      });
      $('#panel-articles .image-element__wrap').each(function(){
        $(this).height(minImageHeight);
      });
      // console.log({minImageHeight});

    }
    return false;
  });

  // $('body').on('click','.cart-accordion__button',function(){
  //   // console.log('real cart accordion click');
  //   var faqIcons = $(this).find('.icon');
  //   var state = $(this).attr('aria-expanded') === 'false' ? true : false;
  //   $(this).attr('aria-expanded', state);
  //   $(this).parent().next().slideToggle(function () {
  //     if (faqIcons.hasClass('icon--active')) {
  //       faqIcons.toggleClass('icon--active');
  //     }
  //   });
  //   $(this).parent().next().attr('aria-hidden', !state);
  //   return false;
  // });

  // cart champion popup
  $("#cart_form #checkout").on("click", function(e) {
    var champion_popup = $(".cart-champion-popup");
    if (champion_popup.length > 0 && champion_popup.hasClass("popup-hide")) {
      e.preventDefault();
      champion_popup.removeClass("popup-hide");
      champion_popup.attr("data-flag", "cartPage");
    }
  })

  $('[data-ajax-cart-drawer]').on("click", ".button--add-to-cart", function(e) {
    var champion_popup = $(".cart-champion-popup");
    if (champion_popup.length > 0 && champion_popup.hasClass("popup-hide")) {
      e.preventDefault();
      champion_popup.removeClass("popup-hide");
      champion_popup.attr("data-flag", "drawer");
    }
  })
  $(".shopify-payment-button").on("click", function(e) {
    var champion_popup = $(".cart-champion-popup");
    if (champion_popup.length > 0 && champion_popup.hasClass("popup-hide")) {
      e.preventDefault();
      e.stopPropagation();
      champion_popup.removeClass("popup-hide");
      champion_popup.attr("data-flag", "BuyNow");
    }
  })

  $(".cart-champion-popup .fc-item").on("click", function() {
    var notes = $(this).data("note");

    if ($(".cart-champion-popup").attr("data-flag") == "drawer") {
      var origin_notes = $('.ajax-cart__form textarea[name="note"]').text();
      var index = origin_notes.indexOf("Superbowl");
      // console.log(index);
      if (index > 0) {
        origin_notes = origin_notes.substr(0, index);  
      } else {
        origin_notes = '';
      }
      // console.log(origin_notes);
      var final_notes = origin_notes + " " + notes;
      $('.ajax-cart__form textarea[name="note"]').text(final_notes);
      $(".ajax-cart__form .button--add-to-cart").trigger("click");
    } else if ($(".cart-champion-popup").attr("data-flag") == "BuyNow") {
      var updateData = {
        'note': notes
      };
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updateData)
      })
      .then(response => {
        $(".shopify-payment-button").trigger("click");
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    } else {
      var origin_notes = $('#cart_form .cart__notes textarea[name="note"]').text();
      var index = origin_notes.indexOf("Superbowl");
      if (index > 0) {
        origin_notes = origin_notes.substr(0, index);  
      }  else {
        origin_notes = '';
      }
      var final_notes = origin_notes + " " + notes;
      $('#cart_form .cart__notes textarea[name="note"]').text(final_notes);
      $("#cart_form #checkout").trigger("click");
    }
  })
  
  $('.featured-list-slider-nav').on('init', function(event, slick){
    $slideNodes = $(this).find('.thumbnail-image');
    $slideNodes.each(function(){
      $(this).addClass('found-thumb-wulf');
      $(this).contents().filter(function() {
        // get only the text nodes
        return this.nodeType === 3;
      })
      .remove();
    });
    $(this).addClass('wulf-init');
  });
  
  function initFeaturedSlides() {
    $('.featured-list-slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      infinite: true,
      asNavFor: '.featured-list-slider-nav'
    });
    $('.featured-list-slider-nav').slick({
      slidesToShow: 4,
      slidesToScroll: 1,
      vertical:true,
      infinite: true,
      asNavFor: '.featured-list-slider-for',
      dots: false,
      focusOnSelect: true,
      verticalSwiping:true,
      responsive: [
        {
          breakpoint: 580,
          settings: {
            vertical: false,
          }
        }
      ]
    });
  }

  function destroyFeaturedSlides() {
    $('.featured-list-slider-for').slick('unslick');
    $('.featured-list-slider-nav').slick('unslick');
  }

  initFeaturedSlides();
  
  $('body').on('click', '.wholesale-featured-slide', function() {
    var dataNum = $(this).data('num');
    $('.wholesale-featured-list').removeClass('active');
    //$('.wholesale-featured-list[data-num="' + dataNum + '"]').addClass('active');
    
    var $newActiveSlide = $('.wholesale-featured-list[data-num="' + dataNum + '"]');
    // console.log($newActiveSlide);
    $newActiveSlide.addClass('active');
    
    
    $([document.documentElement, document.body]).animate({
        scrollTop: $newActiveSlide.offset().top + (-100)
    }, 1000);
    
    
    destroyFeaturedSlides();
    initFeaturedSlides()
  });

  // Back In Stock Popup
  // Remember the iframe only appears after an interaction to init the the popup
  // Iframe does share the same origin
  const bisObserver = new MutationObserver(function(muts, obs) {
    const iframe = $('#BIS_frame');
    
    if (iframe.length) {
      const iframeBody = iframe.contents().find('body').first();
      const popup = iframeBody.find('#BISModal').first();
      const popupContent = popup.find('.modal-content').first();
      const popupClose = popup.find('.close').first();

      // Re-usable function(s)
      const closePopup = function() { // Re-usable close function
        popupClose.trigger('click');
      }

      // Handle click events
      iframeBody.on('click', function(event) {
        const nonClickables = $(event.target).closest(popupContent).length;

        if (nonClickables === 0) {
          closePopup();
        }
      });

      // Handle esc key events
      // Remember modal does not trap the keyboard so target both the doc and the el
      $(document).add(iframeBody).on('keyup', function (event) {
        if (event.keyCode === 27 && iframe.is(':visible')) {
          closePopup();
        }
      });
    }
  });

  bisObserver.observe(document.body, {
    childList: true,
    subtree: false // BIS iframe is placed as a child of the body, no need for subtree
  });
});

$(window).on('scroll', function () {
  atcFormIsInView();
});

function atcFormIsInView() {
  var $buttons = $('.purchase-details__buttons');
  var $details = $('.purchase-details.desktop-hide');
  
  if ($buttons.length && $details.length) {
    var top = $(window).scrollTop(),
        bottom = $(window).scrollTop() + $(window).height(),
        divTop = $details.offset().top - 30,
        divHeight = $buttons.outerHeight(),
        divBottom = divTop + divHeight + 30;

    if (divBottom > top && divTop < bottom) {
      $('body').removeClass('add-to-cart-out-of-view');
    } else {
      $('body').addClass('add-to-cart-out-of-view');
    }
  }
}

// Force Klaviyo form to open in same tab
document.addEventListener('click', function(e) {
  const link = e.target.closest('a');
  if (link && link.closest('.klaviyo-form')) {
    link.removeAttribute('target');
  }
});

// Fix: QuickView quantity buttons double-firing on older iPads (pre-2022)
// On older iOS WebKit, touch events promote to a synthetic click, causing
// double or triple increments. Timestamp guard replaces sourceCapabilities
// which is unavailable on older WebKit versions.
$(document).ready(function () {
  var lastTouchTime = 0;
  var isTouch = false;

  // Detect if this is a touch-capable device at all -- if not, skip entirely
  // and leave utilities.js handlers completely untouched for desktop
  window.addEventListener('touchstart', function onFirstTouch() {
    isTouch = true;
    window.removeEventListener('touchstart', onFirstTouch);

    // Remove 'change' from input binding -- programmatic .val() calls trigger
    // change events, causing an extra increment on every button tap
    $('body').off('keyup keydown change', '.quantity-input');
    $('body').on('keyup keydown', '.quantity-input', function () {
      window.PXUTheme.quantityBox.updateQuantity($(this));
    });

    // Handle touch explicitly, then block the synthetic click that follows
    $('body').on('touchend', '[data-update-quantity]:not([disabled])', function (e) {
      e.preventDefault();
      lastTouchTime = Date.now();
      window.PXUTheme.quantityBox.updateQuantity($(this));
    });

    // Only handle click if it didn't originate from a touch event
    $('body').off('click', '[data-update-quantity]:not([disabled])');
    $('body').on('click', '[data-update-quantity]:not([disabled])', function () {
      if (Date.now() - lastTouchTime < 500) return;
      window.PXUTheme.quantityBox.updateQuantity($(this));
    });
  }, { passive: true });
});
